// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__i3MFW","col":"styles_col__1Hk_C"};